import React, { useEffect } from 'react';
import Routes from "./Routes";
import api from "./helpers/api";
import { getLoggedinUser } from "./helpers/api_helper";
import useSessionKeepAlive from "./Hooks/useSessionKeepAlive";
import './App.css'
import 'boxicons/css/boxicons.min.css';

// Import Scss
import './assets/scss/theme.scss';

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
fakeBackend();

// Firebase
// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

function App() {
  // Boot-time session reconcile. If localStorage says we're logged in, verify the
  // cookie session is actually alive via /auth/me. A dead session routes through
  // the api interceptor (transparent refresh, or logout if that fails) instead of
  // rendering a stale authenticated shell that only breaks on the first data call.
  // Skipped when there's no authUser (e.g. the SSO callback route handles its own
  // /auth/me), so this never double-fires during login.
  useEffect(() => {
    if (getLoggedinUser()) {
      api.get("auth/me").catch(() => { /* interceptor handles refresh / logout */ });
    }
  }, []);

  // Proactively refresh the access token before it can expire under an active user,
  // so long form fills / idle-but-open tabs never surface an "Unauthorized, please
  // log in" 401. Reactive refresh (helpers/api.js) remains the safety net.
  useSessionKeepAlive();

  return (
    <React.Fragment>
      <Routes />
    </React.Fragment>
  );
}

export default App;
